class StickyAtc extends HTMLElement {
    constructor() {
      super();
      this.addToCartBtn = null;
      this.quantityInput = null;
      this.quantityPlus = null;
      this.quantityMinus = null;
      this.checkbox = null;
      this.isVisible = false;
    }

    connectedCallback() {
      this.initializeComponent();
      this.setupEventListeners();
      this.setupScrollHandler();
    }

    initializeComponent() {
      this.addToCartBtn = this.querySelector('.btn[data-action="add-to-cart"]');

      this.quantityContainer = this.querySelector('.sticky-atc__quantity-wrapper .quantity');
      this.originalQuantityContainer = document.querySelector('.product-form__inputs-wrapper #quantity'); 

      this.originalCheckbox = document.querySelector('.product__extra-qty-block [type="checkbox"]');
      this.checkbox = this.querySelector('.sticky-atc__checkbox .checkbox-input');

      this.mainAddToCartBtn = document.querySelector('.product__info-wrapper product-form .product-form__submit');
    }

    setupEventListeners() {
      if (this.addToCartBtn) {
        this.addToCartBtn.addEventListener('click', () => this.handleAddToCart());
      }

      if (this.quantityContainer) {
        this.quantityPlus = this.quantityContainer.querySelector('.plus');
        this.quantityMinus = this.quantityContainer.querySelector('.minus');
        this.quantityInput = this.quantityContainer.querySelector('input');

        if (this.originalQuantityContainer) {
          this.originalQuantityContainer.addEventListener('input', () => {
            this.quantityInput.value = this.originalQuantityContainer.value;
            this.updateUnitText(this.quantityInput.value);
          });
        }

        if (this.quantityInput) {
          this.quantityInput.addEventListener('input', () => {
            this.originalQuantityContainer.value = this.quantityInput.value;
            this.originalQuantityContainer.dispatchEvent(new Event('input', { bubbles: true }));
            this.updateUnitText(this.quantityInput.value);
          });
        }

        if (this.quantityPlus) {
          this.quantityPlus.addEventListener('click', () => this.handleQuantityChange(1));
        }

        if (this.quantityMinus) {
          this.quantityMinus.addEventListener('click', () => this.handleQuantityChange(-1));
        }
      }

      if (this.checkbox) {
        this.checkbox.addEventListener('click', (e) => this.handleCheckboxChange(e.target));
      }

      if (this.originalCheckbox) {
        this.originalCheckbox.addEventListener('click', (e) => this.handleCheckboxChange(e.target));
      }
    }

    setupScrollHandler() {
      // Listen for scroll events
      window.addEventListener('scroll', () => this.handleScroll());

      // Initialize on setup
      this.handleScroll();
    }

    handleAddToCart() {
      if (this.mainAddToCartBtn) {
        this.mainAddToCartBtn.click();
      }
    }

    handleQuantityChange(change) {
      if (!this.quantityInput) return;

      let currentVal = parseInt(this.quantityInput.value);
      let newVal = currentVal + change;

      // Ensure quantity doesn't go below 1
      if (newVal < 1) newVal = 1;
      this.originalQuantityContainer.value = newVal;
      this.originalQuantityContainer.dispatchEvent(new Event('input', { bubbles: true }));
      this.quantityInput.value = newVal;

      this.updateUnitText(newVal);
    }

    updateUnitText(val) {
      this.unitText = this.quantityContainer.querySelector('.unit');
      
      if (this.unitText) {
        if (val === 0) {
          this.unitText.textContent = '';
          return;
        }
        setTimeout(() => {
          if (this.unitText.dataset.unit === 'box') {
            if (!this.querySelector('.calc_total small')) {
              this.unitText.textContent = '';
              return;
            } 
            const squareText = this.querySelector('.calc_total small').textContent.match(/\(.*?\)/g);
            this.unitText.textContent = val > 1 ? 'Boxes ' + squareText : 'Box ' + squareText;
          } else if (this.unitText.dataset.unit === 'sheet') {
            if (!this.querySelector('.calc_total small')) {
              this.unitText.textContent = '';
              return;
            }
            const squareText = this.querySelector('.calc_total small').textContent.match(/\(.*?\)/g);
            this.unitText.textContent = val > 1 ? 'Sheets ' + squareText : 'Sheet ' + squareText;
          }
        }, 100);
      }

      if (val > 99) {
        this.quantityInput.style.width = '35px';
      } else if (val >= 10) {
        this.quantityInput.style.width = '25px';
      } else if (val < 10) {
        this.quantityInput.style.width = '15px';
      }
    }

    handleCheckboxChange(elem) {
      // Your checkbox logic here
      if (elem.closest('.sticky-atc__checkbox')) {
        this.originalCheckbox.click();
        this.quantityContainer.querySelector('input').value = this.originalQuantityContainer.value;
        this.updateUnitText(this.originalQuantityContainer.value);
      } else {
        this.checkbox.checked = elem.checked;
        setTimeout(() => {
          this.quantityContainer.querySelector('input').value = this.originalQuantityContainer.value;
          this.updateUnitText(this.originalQuantityContainer.value);
        }, 10);
      }
    }

    handleScroll() {
      if (!this.mainAddToCartBtn) return;

      const scrollPosition = window.scrollY;
      const mainBtnPosition = this.mainAddToCartBtn.getBoundingClientRect().top + window.scrollY;

      if (scrollPosition > mainBtnPosition) {
        this.showComponent();
      } else {
        this.hideComponent();
      }
    }

    showComponent() {
      if (!this.isVisible) {
        this.querySelector('.sticky-atc').classList.add('sticky-atc--visible');
        this.isVisible = true;
      }
    }

    hideComponent() {
      if (this.isVisible) {
        this.querySelector('.sticky-atc').classList.remove('sticky-atc--visible');
        this.isVisible = false;
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', () => this.handleScroll());

      if (this.addToCartBtn) {
        this.addToCartBtn.removeEventListener('click', () => this.handleAddToCart());
      }

      if (this.quantityPlus) {
        this.quantityPlus.removeEventListener('click', () => this.handleQuantityChange(1));
      }

      if (this.quantityMinus) {
        this.quantityMinus.removeEventListener('click', () => this.handleQuantityChange(-1));
      }

      if (this.checkbox) {
        this.checkbox.removeEventListener('click', () => this.handleCheckboxChange());
      }
    }
  }

  // Register the custom element
  customElements.define('sticky-atc', StickyAtc);